'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var showLinkageShare = exports.showLinkageShare = function showLinkageShare(originData) {
  var data = originData || {};
  var values = Object.values(data) || [];
  var show = false;
  values.forEach(function (item) {
    var arr = Array.isArray(item) ? item : item.data || [];
    if (arr.length) {
      show = true;
    }
  });
  return show;
};

var getShowContentList = function getShowContentList(originOption, originFields) {
  var option = originOption || {};
  var showFields = originFields || {};
  var keys = Object.keys(option);
  var showKeys = Object.keys(showFields);
  var showObj = {};
  keys.forEach(function (item) {
    if (showKeys.includes(item)) {
      showObj[item] = option[item];
    }
  });
  var valueArr = Object.keys(showObj);
  var finalList = [];
  valueArr.forEach(function (item) {
    var value = showObj[item];
    var field = showFields[item];
    var type = field.type,
        _field$fields = field.fields,
        fields = _field$fields === undefined ? {} : _field$fields;

    if (Object.prototype.toString.call(value) === '[object Object]' && (value.text || value.name)) {
      value = value.text || value.name;
    }
    if (value.startDate || value.endDate) {
      var format = (fields.format || 'YYYY-MM-DD').toUpperCase();
      value = (moment(value.startDate).format(format) || '无') + '~' + (moment(value.endDate).format(format) || '无');
    }
    if (type === 'Date') {
      var _format = (fields.format || 'YYYY-MM-DD').toUpperCase();
      value = moment(value).format(_format);
    }
    if (Array.isArray(value)) {
      value = value.map(function (i) {
        return i.text || i.name;
      }).join(',');
    }
    if (JSON.stringify(value) === '{}') {
      value = '';
    }
    if (value) {
      finalList.push(JSON.stringify(value));
    }
  });
  return finalList;
};

var getLinkageShareData = exports.getLinkageShareData = function getLinkageShareData() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$linkageShareKe = props.linkageShareKeysConfig,
      linkageShareKeysConfig = _props$linkageShareKe === undefined ? {} : _props$linkageShareKe,
      _props$linkageShareDa = props.linkageShareData,
      linkageShareData = _props$linkageShareDa === undefined ? {} : _props$linkageShareDa,
      context = props.context,
      children = props.children;

  var compDataInfo = {};
  (children || []).forEach(function (item) {
    var comp = item.props.componentSchema.props;
    compDataInfo[comp.fieldId] = comp;
  });
  var linkageKeys = Object.keys(compDataInfo);
  var shareDataKeys = Object.keys(linkageShareData);
  var configShareKeys = Object.keys(linkageShareKeysConfig);
  var finalCompKeys = configShareKeys.filter(function (key) {
    return shareDataKeys.includes(key);
  });
  var showData = [];
  finalCompKeys.forEach(function (key) {
    var showKeys = []; // 显示字段
    var shareData = [];
    var fieldData = context.store.get(key) || {};
    var label = fieldData.componentSchema.props.label;
    var value = fieldData.getVal();
    var originData = Array.isArray(value) ? value : value && value.data || [];
    var configKeysInfo = linkageShareKeysConfig[key];
    var configKeys = Object.keys(configKeysInfo);
    originData.forEach(function (item, index) {
      var keys = Object.keys(item);
      var obj = null;
      configKeys.forEach(function (i) {
        var _i$split = i.split(':'),
            _i$split2 = _slicedToArray(_i$split, 2),
            key1 = _i$split2[0],
            key2 = _i$split2[1];

        if (keys.includes(key1) && linkageKeys.includes(configKeysInfo[i]) && item[key1]) {
          obj = obj || {};
          obj[configKeysInfo[i]] = item[key1];
        }
        if (obj && obj[configKeysInfo[i]] && key2 && !Object.keys(showKeys).includes(configKeysInfo[i])) {
          showKeys[configKeysInfo[i]] = compDataInfo[configKeysInfo[i]];
        }
      });
      var labelList = getShowContentList(obj, showKeys);
      if (obj && labelList.length) {
        shareData.push(_extends({}, obj, { selected: false, labelList: labelList
        }));
      }
    });

    if (label && shareData.length) {
      showData.push({
        label: label,
        shareData: shareData,
        open: true
      });
    }
  });
  return showData;
};